export default __webpack_public_path__ + "static/media/export.7060bf0f.svg";